module.exports = __webpack_public_path__ + "static/img/tooltip-sun-zenith-angle.40478a5.png";